import { Component } from 'react';
import Raven from 'raven-js';
export default class BaseErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(__error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    const {
      onError
    } = this.props;
    Raven.captureException(error);
    if (onError) {
      onError(error, errorInfo);
    }
  }
  render() {
    if (this.state.hasError) {
      return this.props.fallback || null;
    }
    return this.props.children;
  }
}